import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_ROLES_ACTION_TYPE } from '../actions';

const initialState = {};

const loanRolesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_ROLES_ACTION_TYPE.GET_LOAN_ROLES:
        return payload || state;

      case LOAN_ROLES_ACTION_TYPE.CREATE_LOAN_ROLE:
      case LOAN_ROLES_ACTION_TYPE.EDIT_LOAN_ROLE:
        draft[payload.loanRoleId] = payload;
        break;

      case LOAN_ROLES_ACTION_TYPE.DELETE_LOAN_ROLE:
        delete draft[meta.loanRoleId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanRolesReducer;
